import { useEffect, useRef, useState } from "react";
import { NotificationManager } from "react-notifications";
import { CorrelativoInicialPalletApi } from "../api/CorrelativoInicialPalletApi";
import { getErrorFromResponse } from "../../../../../utility/utils";

// Estado del correlativo inicial de pallets: lo usa la pantalla que lo
// configura y las pantallas que registran movimientos, para saber si el
// sistema ya se puede utilizar
export const useCorrelativoInicialPallet = () => {
    const { getCorrelativoInicial, configurarCorrelativoInicial, cargando } =
        CorrelativoInicialPalletApi();

    const [estado, setEstado] = useState(null);

    // estado del año que se elige en el formulario, para avisar cuántos pallets
    // de ese año se renumerarían; el estado general sigue siendo el de la
    // configuración guardada
    const [estadoAnioElegido, setEstadoAnioElegido] = useState(null);
    const consultaAnioRef = useRef(0);

    const CargarEstado = async () => {
        try {
            const response = await getCorrelativoInicial();
            setEstado(response);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el correlativo inicial de pallets",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        CargarEstado();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // sin año se usa el estado general
    const CargarEstadoAnio = async (anioElegido) => {
        consultaAnioRef.current += 1;
        const consulta = consultaAnioRef.current;

        setEstadoAnioElegido(null);

        if (!anioElegido) return;

        try {
            const response = await getCorrelativoInicial({
                anio: anioElegido,
            });

            if (consulta !== consultaAnioRef.current) return;

            setEstadoAnioElegido(response);
        } catch (error) {
            if (consulta !== consultaAnioRef.current) return;

            const errorMsg = getErrorFromResponse(
                error,
                "Error al consultar los pallets del año",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const ConfigurarCorrelativo = async (anioElegido, correlativoInicial) => {
        try {
            const response = await configurarCorrelativoInicial({
                anio: anioElegido,
                correlativo_inicial: correlativoInicial,
            });

            setEstado(response);
            setEstadoAnioElegido(null);

            let mensaje = "Correlativo inicial configurado";

            if (response && response.pallets_corridos) {
                mensaje += `. Se renumeraron ${response.pallets_corridos} pallets ya creados`;
            }

            NotificationManager.success(mensaje, "Éxito", 3000);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al configurar el correlativo inicial",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    // mientras responde el servidor se asume configurado, para no mostrar el
    // bloqueo en un parpadeo
    const configurado = estado ? estado.configurado : true;
    const editable = estado ? estado.editable : false;
    const anio = estado ? estado.anio : null;
    const totalPallets = estado ? estado.total_pallets_anio : 0;

    // pallets del año elegido en el formulario, que se renumerarían al guardar
    const totalPalletsAnioElegido = estadoAnioElegido
        ? estadoAnioElegido.total_pallets_anio
        : totalPallets;

    const correlativoInicial =
        estado && estado.configuracion
            ? estado.configuracion.correlativo_inicial
            : null;

    return {
        estado,
        configurado,
        editable,
        anio,
        totalPallets,
        totalPalletsAnioElegido,
        correlativoInicial,

        CargarEstado,
        CargarEstadoAnio,
        ConfigurarCorrelativo,
        cargando,
    };
};
